import Handlebars from "handlebars";

const reshareCTA = `
  <div style="border: 0px none; background-color: #ffffff; display: inline-block;">
    <a href="{{defaultValue @root.contact.url 'contact.url'}}/collections/{{share.id}}"  
      data-widget-placeholder="{{contact.url}}/collections/{{share.id}}" 
      style="
        border: 10px solid {{defaultValue librarySettings.primaryColor '#E51058'}};
        background-color: {{defaultValue librarySettings.primaryColor '#E51058'}};
        font-family: {{defaultValue theme.brandFont 'Montserrat, Helvetica, Arial, sans-serif'}};
        color: {{defaultValue librarySettings.buttonTextColor '#ffffff'}};
        padding: 0px; 
        display: inline-block;
        text-decoration: none;">
      View Content
    </a>
  </div>
`;

const template = Handlebars.compile(reshareCTA);

export default template;
